import React, { useCallback } from 'react';

import { Icon } from '@rbilabs/universal-components';
import { GestureResponderEvent } from 'react-native';

import { CustomEventNames } from 'state/amplitude/constants';
import { t } from 'state/intl/translations';
import LocalStorage from 'utils/local-storage';
import { Keys } from 'utils/local-storage/constants';

import { StyledButton } from './place-order-button.styled';
import { IPlaceOrderButtonProps } from './types';

const PlaceOrderButton: React.FC<React.PropsWithChildren<IPlaceOrderButtonProps>> = ({
  placeOrderAriaLabel,
  disabled,
  onPress,
  isLoading,
  confirmation,
}) => {
  const placeOrderTextKey = confirmation ? 'placeSecureOrder' : 'continue';
  const placeOrderText = t(placeOrderTextKey, {
    secureOrderIcon: '',
  });

  const onPressWithReset = useCallback(
    (ev: GestureResponderEvent) => {
      if (confirmation) {
        LocalStorage.removeItem(Keys.LOCK_SCREEN_LAST_ORDER_STATUS);
      }
      onPress && onPress(ev);
    },
    [confirmation, onPress]
  );

  return (
    <StyledButton
      fullWidth
      eventAttributes={{ Name: CustomEventNames.BUTTON_CLICK_PLACE_ORDER }}
      onPress={onPressWithReset}
      accessibilityLabel={confirmation ? placeOrderAriaLabel : undefined}
      accessibilityRole="button"
      testID={confirmation ? 'place-order' : 'continue-order'}
      disabled={disabled}
      isLoading={isLoading}
      startIcon={confirmation ? <Icon variant="locked" /> : undefined}
    >
      {placeOrderText}
    </StyledButton>
  );
};

export default PlaceOrderButton;
